<template>
  <div class="wrapper page-klk-container dkt">
    <div class="container">
      <Banner desc="快乐看，让知识有趣一点。这是芒果TV与湖南省教育厅联合打造的一个教育知识类中短视频平台，致力发掘更多公办优质教育内容创作者，生产符合教育规律的内容，五育并举、知识普惠，素养提升。以湖南IPTV为基础，全国首创联动手机和PC端三屏互动，多入口、高品质、纯公益、更护眼。" :bannerInfo="bannerInfo" @play="onPlayClick"></Banner>
      <Character v-if="characterList.length" :character-list="characterList"></Character>
      <Topic :page-name="'klk'" :topic-list="topicList" @play="onPlayClick"></Topic>
    </div>
    <div class="footer-bg"></div>
  </div>
</template>
<script>
import Banner from '@/components/banner.vue'
import Character from '@/components/character.vue'
import Topic from '@/components/topic'
import axios from '@/utils/request'
import jumpPage from '@/utils/utils'

export default {
  components: {
    Banner,
    Character,
    Topic
  },
  data () {
    return {
      // vclassId: (false ? 1431905 : 742936),
      vclassId: (process.env.NODE_ENV === 'production' ? 1431905 : 742936),
      bannerInfo: {
        videoList: []
      },
      characterList: [],
      topicList: []
    }
  },
  mounted () {
    this.getData()
    document.body.setAttribute('mg-stat-page', 'klk_happyLook')
    window.MgStat.send('pv', {}, {src: 'klk'}) // 手动发送PV
  },
  methods: {
    getData () {
      axios.get(`${this.serverUrl}/home/cms/list?vclassId=${this.vclassId}`).then(res => {
        const moduleData = res.data.moduleList
        let topicList = []
        moduleData.map(item => {
          if (item.ottModuleType === 'web_banner') {
            this.bannerInfo.videoList = item.videoList
          } else if (item.ottModuleType === 'character_module') {
            this.characterList = item.videoList
          } else if (item.ottModuleType === 'topic_module') {
            topicList.push({videoList: item.videoList, moduleTitle: item.moduleTitle, caseId: item.caseId})
          }
        })
        this.topicList = topicList
      })
    },
    onPlayClick: function (video) {
      let url = jumpPage(video)
      window.open(`${this.videoPlayUrl}${url}`, '_blank')
      // const vid = video.jumpDefaultParam[0].value
      // // modal.player && modal.player.fetchVideoInfo(vid);
      // // modal.qrCode = getKlkUrl(video);
      // // jumpID是3605就是学习计划，3602是单视频
      // const isPlan = video.jumpId == 3605
      // window.open(window.location.origin + window.location.pathname + `#/video?type=${isPlan?'plan':'video'}&id=${vid}&cxid=${isPlan?'1s6lhj7va':'2fvxf8uus'}`, '_blank');
    }
  }
}
</script>
<style scoped>
  .page-klk-container {
    background-image: url("./images/klk-top.jpg");
    background-repeat: no-repeat;
    background-color: #AED8F4;
  }
  .footer-bg {
    background: url("./images/klk-bottom.jpg")no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/pages/klk.vue